import { CashierSessionTypes } from './../const/cashier-session-types';
import { Check } from '@sparkware/app-utils';

export function isDepositSessionType(sessionType: number | string | null | undefined): boolean {
    if(Check.isNullOrUndefined(sessionType)) {
        return true;
    }

    sessionType = sessionType.toString();
    return sessionType === CashierSessionTypes.QUICK_DEPOSIT.toString()
        || sessionType === CashierSessionTypes.FULL_CASHIER.toString()
        || sessionType === CashierSessionTypes.DEPOSIT.toString();
}

export function isCashoutSessionType(sessionType: number | string | null | undefined): boolean {
    // cashout should be open only when session type is defined and only if is withdrawal
    if(Check.isNullOrUndefined(sessionType)) {
        return false;
    }

    sessionType = sessionType.toString();
    return sessionType === CashierSessionTypes.WITHDRAWAL.toString();
}